import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Provides access to the images API.
 * */
@Injectable({ providedIn: 'root' })
export class ImagesApiService {
  apiUrl = '/api';

  constructor(private http: HttpClient) {

  }

  getLatest(): Observable<any[]> {
    return this.http.get<[]>(`${this.apiUrl}/images/latest`);
  }
}
